import React from "react";

const BorderGradient = () => {
  return (
    <>
      <div className="h-1 lg:h-2 w-full bg-utiva-green" />
      <div className="h-1 lg:h-2 w-full bg-primary2" />
      <div className="h-1 lg:h-2 w-full bg-secondary" />
    </>
  );
};

export default BorderGradient;
